import JSZip from 'jszip'
import { createImageSimple, download } from './utils'

import { saveAs } from 'file-saver'

export const batchExportImage = async charts => {
  const zip = new JSZip()
  for (let i = 0; i < charts.length; i++) {
    const { chart, chartElement, title, header, caption } = charts[i]

    const image = createImageSimple(
      { caption, title: title || header },
      { chart: chartElement?.chart || chart },
    )
    const blob = await fetch(image).then(response => {
      return response.blob()
    })
    zip.file(`${title}${i + 1}.png`, blob, { base64: true })
  }
  zip.generateAsync({ type: 'blob' }).then(function (blob) {
    saveAs(blob, 'charts.zip')
  })
}

export const exportImage = async (charts = []) => {
  if (charts.length === 0) {
    return ''
  }
  const { chart, chartElement, title, header, caption } = charts[0]
  const image = createImageSimple(
    { caption, title: title || header },
    { chart: chartElement?.chart || chart },
  )
  return await download(image, title || header, 'png')
}
